export const TRANSITION_SPEED = 300;
export const MOBILE_BREAKPOINT = 1120; // match in shared.scss

export const DARK_MODE_HASH = "#dark";
export const LIGHT_MODE_HASH = "#light";
